import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postItems, getItems } from "../../redux/actions/actionItem";

export default function ItemsCreate(){
    const initialForm = {
        //idItem:"",
        name:"",
        description:"",
        value: 0,
        stock:"",
        stockTotal:""
    }

    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const items = useSelector(state => state.items.allItems);
    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({})
            
    useEffect(() => {
        dispatch(getItems());
    }, [dispatch])

    console.log(items.length)

    const codigoItems = items.length + 1
    console.log(codigoItems)

    const handleError = (form) => {
        let errors = {};

        if (!form.name.trim()){
            errors.name = "Es requerido el nombre"
        }
        
        if (!form.description.trim()){
            errors.description = "Es requerida la descripcion"
        }

        return errors;
    }

    const handleBlur = (e) => {
        handleChange(e)
        setErrors(handleError(form))
    }
    
    const handleChange = (e) =>{
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    };

    const handleSubmit = () => {
        dispatch(postItems(form));
        setForm({
            idItem:"",
            name:"",
            description:"",
            stock:"",
            stockTotal:"",
            value:""
        })
        setTimeout(() => {
            navigate("/items/listado")
        }, 300);
    }

    return (
        <div className="min-w-full max-w-screen-2xl bg-gray-900">
            <form onSubmit={handleSubmit}>
                <div className="m-8 text-orange-500 font-bold">
            <div>
                <p className="text-xl pb-8 underline">Articulos - Nuevo</p>
            </div>
                    <div className="flex">
                        <label className="w-40">Id producto</label>
                            <input
                                className="w-28 text-center bg-slate-700"
                                type="text"
                                name="idItem"
                                placeholder="idItem"
                                onChange={handleChange}
                                value={codigoItems}
                                required={true}
                                />                        
                    </div>
                    <div className="flex mt-4 mb-4">
                        <label className="w-40">Nombre</label>
                            <input
                                className="w-1/3 text-center bg-slate-700"
                                type="text"
                                name="name"
                                placeholder="nombre"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={form.name}
                                required={true}
                                />
                                {errors.name && <p className="text-red-600 pl-2 text-[9pt]">{errors.name}</p>}                        
                    </div>
                    <div className="flex mb-4">
                        <label className="w-40">Descripcion</label>
                            <input
                                className="w-1/3 text-center bg-slate-700"
                                type="text"
                                name="description"
                                placeholder="descripcion"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={form.description}
                                required={true}
                                /> 
                                {errors.description && <p className="text-red-600 pl-2 text-[9pt]">{errors.description}</p>}                       
                    </div>
                    <div className="flex mb-4">
                        <label className="w-40">Cantidad</label>
                            <input
                                className="w-1/3 text-center bg-slate-700"
                                type="number"
                                name="stock"
                                placeholder="stock"
                                onChange={handleChange}
                                value={form.stock}
                                required={true}
                                />                        
                    </div>
                    <div className="flex mb-4">
                        <label className="w-40">Cantidad Total</label>
                            <input
                                className="w-1/3 text-center bg-slate-700"
                                type="number"
                                name="stockTotal"
                                placeholder="stockTotal"
                                onChange={handleChange}
                                value={form.stockTotal=form.stock}
                                required={true}
                                />                        
                    </div>
                    <div className="flex">
                        <label className="w-40">Valor</label>
                            <input
                                className="w-1/3 text-center bg-slate-700"
                                type="number"
                                name="value"
                                placeholder="valor"
                                onChange={handleChange}
                                value={form.value}
                                required={true}
                                />                        
                    </div>
                    <div>
                    <button className="mt-12 p-4 rounded bg-sky-500 text-white hover:bg-red-600" onClick={handleSubmit}>Guardar</button>
                    </div>
                </div>
            </form>
        </div>
    )
}